import React from "react";
import { useNavigate } from "react-router-dom";

import "../pages/AllWeather.css";
import awoHero from "../images/awo/awo_hero.jpg"
import cat3c from "../images/awo/cat3c.jpg"

const AllWeatherPublic = (props) => {

    const navigate = useNavigate();

    const handleViewManual = () => {
        navigate('/documents?doc=awo-handbook');
    };
    console.log(props.cat23)
    return(
        <React.Fragment>
            <div className="awo-page dark-theme">
                {/* Hero Section */}
                <div className="awo-hero">
                    <img src={awoHero} alt="AWO Landing" className="awo-hero-image" />

                </div>

                {/* Main Content Container */}
                <div className="awo-content">
                    
                    {/* Introduction Card */}
                    <section className="awo-card awo-intro-card">

                        <div className="awo-card-content">
                            <h2 className="awo-card-title">Landing in low visibility</h2>
                            <p className="awo-description">
                                Is one of the most exciting ways to operate an aircraft, 
                                and also the most demanding. The All Weather Operations (AWO)
                                group recognizes pilots at FDXVA who meet the flight crew
                                requirements necessary for Category II, IIIa, IIIb, and IIIc
                                authorization.
                            </p>
                        </div>

                        <div className="awo-requirement-item">
                            <div>
                               
                            <img src={cat3c} alt="CAT IIIc" className="awo-cat3c-image"/>

                            </div>
                            <div className="requirement-content">
                                <h3 className="requirement-title">Initial Membership Requirements</h3>
                                <p className="requirement-description">Read the AWO Manual + log 100 hours of flight time + 50 flights with IFR approach conditions, one of which was in the previous 30 days</p>
                                <div className="awo-buttons">

                                    <button
                                        className="awo-manual-button"
                                        aria-label="View All Weather Operations Manual"
                                        onClick={handleViewManual}
                                    >
                                        <span className="button-text">View Manual</span>
                                    </button>

                                    {props.cat23 !== "" && 
                                        <button className="awo-manual-button" 
                                            aria-label="View All Weather Operations Manual"
                                            onClick={props.handleMembersOnly}  
                                            >
                                            <span className="button-text">Members Only</span>
                                        </button>                                    
                                    }


                                </div>
                                
                                
                            </div>
                        </div>                        

                    </section>


                </div>
            </div>
            
        </React.Fragment>)
}
export default AllWeatherPublic;